import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const Upload = React.lazy(() => import('../page/Upload'));

const routes: AppRouteType[] = [
  {
    path: slugs.upload,
    component: Upload,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
